import axios from 'axios';
import { BASE_URL } from '../../../../config/environmentConfig';
import { IOrderAction, IOrderContextState } from '../order-interfaces';
import { makeSearchParams } from '../../../utils/utilities';
import { orderActionTypes } from '../order-action-types';
import { GET } from '../../store-helper';
import * as React from 'react';
import download from 'downloadjs';

const getFundsReserveQueryParams = (state: IOrderContextState, chosenMerchant?: null | string): { [p: string]: string | number | boolean } => {
	const params: { [key: string]: string | number | boolean } = {};

	params.pageSize = state.fundsReserveListTablePageSize;
	params.pageNumber = state.fundsReserveListTablePageNumber + 1;
	if (chosenMerchant !== null && chosenMerchant?.length > 0) {
		params.mid = chosenMerchant;
	}

	return params;
};

export const fetchFundsReserveList = async (dispatch: React.Dispatch<IOrderAction>, state: IOrderContextState, chosenMerchant: null | string): Promise<void> => {
	try {
		const params = getFundsReserveQueryParams(state, chosenMerchant);
		const res = await axios(`${BASE_URL.ORDERS}/fundsReserve`, {
			params,
			paramsSerializer: params => makeSearchParams(params)
		});
		dispatch({
			type: orderActionTypes.FETCH_FUNDS_RESERVE_LIST,
			payload: res?.data || [],
			// totalItemCount: res?.data?.totalItemCount ?? 0
		});
	} catch (e) {
		console.log('fetchFundsReserveList error', e);
		dispatch({ type: orderActionTypes.FETCH_FUNDS_RESERVE_LIST, payload: [] });
	}
};

export const setFundsReserveListToDefault = (dispatch: React.Dispatch<IOrderAction>): void => {
	dispatch({ type: orderActionTypes.SET_FUNDS_RESERVE_LIST_TO_DEFAULT });
};

export const setFundsReservePagination = (dispatch: React.Dispatch<IOrderAction>, value: any): void => {
	dispatch({
		type: orderActionTypes.SET_FUNDS_RESERVE_LIST_PAGINATION,
		payload: {
			pageNumber: value.pageIndex,
			pageSize: value.pageSize
		}
	});
};

export const fetchFundsReserveListDetails = async (dispatch: React.Dispatch<IOrderAction>, state: IOrderContextState, mid): Promise<void> => {
	try {
		dispatch({ type: orderActionTypes.SET_FUNDS_RESERVE_LIST_DETAILS_LOADING, payload: true });
		// const res = await axios(`${BASE_URL.ORDERS}/fundsReserve/${mid}/details?pageSize=${state?.fundsReserveListDetailsTablePageSize}&pageNumber=${state?.fundsReserveListDetailsTablePageNumber}`);
		const res = await axios(`${BASE_URL.ORDERS}/fundsReserve/${mid}/details`);
		dispatch({
			type: orderActionTypes.FETCH_FUNDS_RESERVE_DETAILS_LIST,
			payload: res?.data,
			// totalItemCount: res?.data?.totalItemCount,
			totalItemCount: 10,
		});
	} catch (e) {
		console.log('fetchFundsReserveListDetails error', e);
		dispatch({ type: orderActionTypes.SET_FUNDS_RESERVE_LIST_DETAILS_LOADING, payload: false });
	}
};

export const setFundsReserveDetailsPagination = (dispatch: React.Dispatch<IOrderAction>, value: any): void => {
	dispatch({
		type: orderActionTypes.SET_FUNDS_RESERVE_DETAILS_LIST_PAGINATION,
		payload: {
			pageNumber: value.pageIndex,
			pageSize: value.pageSize
		}
	});
};

export const exportCSVFundsReserveTable = async (dispatch: React.Dispatch<IOrderAction>, mid: string): Promise<void> => {
	try {
		dispatch({ type: orderActionTypes.START_EXPORT_CSV_LOADING });

		const data = await GET({ pathname: `${BASE_URL.ORDERS}/fundsReserve/${mid}/export-details` });

		const blob = new Blob([data], { type: 'text/csv' });
		download(blob, `FundsReserveDetails.csv`);

		dispatch({ type: orderActionTypes.END_EXPORT_CSV_LOADING });
	} catch (e) {
		console.log('exportCSVFundsReserveTable error', e);
		dispatch({ type: orderActionTypes.END_EXPORT_CSV_LOADING });
	}
};